import { AuthDynamoDB } from './dynamodb'
import AwsExports from '@/assets/aws-exports'

export class CrcMasterModel {
  /** ID */
  id: string = ''
  /** 名前 */
  name: string = ''
  /** 表示名 */
  displayName: string = ''

  /** 順序 */
  order: number = 0
  /**
   * データ作成日時
   * ISO8601(UTC)
   */
  createdAt: Date = new Date()
  /**
   * データ更新日時
   * ISO8601(UTC)
   */
  updatedAt: Date = new Date()
}

export default class CrcMasterProvider {
  private readonly TABLE_NAME: string = AwsExports.resourceNamePrefix + '-CrcMaster'
  db: AuthDynamoDB

  constructor () {
    this.db = new AuthDynamoDB()
  }

  /**
   * CRCマスターの全件取得
   */
  async load () {
    const params = {
      TableName: this.TABLE_NAME
    }
    const result = await this.db.scan(params)
    if (!result.Items) {
      throw Error('Cannot load CrcMaster')
    }
    result.Items.sort((a, b) => a.order - b.order)
    console.debug('CrcMaster is loaded.')
    return result.Items as CrcMasterModel[]
  }
}
